/**
 * Mapeo de rutas de deeplink (legacy) → rutas internas de la app actual.
 * Las claves son los paths que llegan en las URLs de deeplink/push notifications.
 * Los valores son las rutas internas a las que se navega.
 *
 * 'image' es especial: no navega, solo guarda params.
 */
export const DEEPLINK_ROUTES: Record<string, string | null> = {
  histogram: '/zoning/hist',
  weather: '/forecast',
  feed: '/feed',
  image: null // solo guarda params, no navega
}
